// extracted by mini-css-extract-plugin
export default {"root":"IconArchery_root__mXDqy"};